import Vue from 'vue'
import c from './constants.js'

let tokenTimeout = 1000 * 60

/**
 * Http interceptor for
 * A: adding the access_token to the header
 * B: redirecting to the login page on a 403 response
 */
export const setupAuthInterceptor = () => {
// Interceptor for access token
//   Vue.http.interceptors.push(function (request) {
//     const token = sessionStorage.getItem(c.ACCESS_TOKEN)
//     if (token) {
//       request.headers.set('Access-Control-Allow-Headers', 'X-CSRF-TOKEN')
//       request.headers.set('X-CSRF-TOKEN', `Bearer ${token}`)
//     }
//
//     return function (response) {
//       // redirect to login, if access is denied
//       if (response.status === 403) {
//         window.location.href = response.body.redirect_url
//       }
//     }
//   })
}

/**
 * Called after some time to get a new access_token
 * before the old access_token expires.
 */
export const refreshToken = () => {
  const refreshTokenValue = sessionStorage.getItem(c.REFRESH_TOKEN)

  Vue.http.get(Vue.prototype.$constants.API_BASEURL + '/refresh_token', {params: {refresh_token: refreshTokenValue}}).then(response => {
    sessionStorage.setItem(c.ACCESS_TOKEN, response.body[c.ACCESS_TOKEN])
    const expiresIn = +response.body[c.EXPIRES_IN] || (tokenTimeout * 2)
    tokenTimeout = expiresIn / 2
    setTimeout(refreshToken, tokenTimeout)
  })
}

// check if the user is logged in
export const checkAuth = (path) => {
  if (sessionStorage.getItem('path') == null) {
    sessionStorage.setItem('path', path)
  }

  return Vue
    .http
    .get(Vue.prototype.$constants.API_BASEURL + '/testOauth')
}

// if path ends in "/callback", try to get a token
export const checkCallback = async () => {
  if (window.location.pathname.endsWith('/callback')) {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')

    await Vue.http.get(Vue.prototype.$constants.API_BASEURL + '/get_token', {
      params: {code}
    }).then(response => {
      // console.log('Token Response: ', response.body)
      sessionStorage.setItem(c.ACCESS_TOKEN, response.body[c.ACCESS_TOKEN])
      sessionStorage.setItem(c.REFRESH_TOKEN, response.body[c.REFRESH_TOKEN])
      const expiresIn = +response.body[c.EXPIRES_IN] || (tokenTimeout * 2)
      tokenTimeout = expiresIn / 2
      setTimeout(refreshToken, tokenTimeout)

      if (sessionStorage.getItem('path') != null) {
        const path = sessionStorage.getItem('path')
        sessionStorage.removeItem('path')
        window.location.pathname = path
      }
    })
  }
}

export default {
  setupAuthInterceptor,
  checkCallback,
  refreshToken,
  checkAuth
}



// WEBPACK FOOTER //
// ./src/auth.js